const FabikraftFeatures = () => {
  return (
    <section className="service_available">
      <div className="container">
        <div className="d-flex">
          <h5>
            <span className="facility_icon">
              <img
                src={require('assets/images/shipping.png').default}
                className="img-responsive"
                alt="shipping"
              />
            </span>
            <span className="thefacility">quick shipping</span>
          </h5>
          <h5>
            <span className="facility_icon">
              <img
                src={require('assets/images/return.png').default}
                className="img-responsive"
                alt="return"
              />
            </span>
            <span className="thefacility">returns and exchanges</span>
          </h5>
          <h5>
            <span className="facility_icon">
              <img
                src={require('assets/images/secure.png').default}
                className="img-responsive"
                alt="secure"
              />
            </span>
            <span className="thefacility">secure payment</span>
          </h5>
        </div>
      </div>
    </section>
  );
};

export default FabikraftFeatures;
